<template>
	<div>
		<div class="explore__header">
			<h1><i class="fas fa-search"></i>Explore</h1>
		</div>
		<div class="explore__content">
			<div class="explore__filters">
				<div class="explore__filter">
					<Dropdown
						:brick="true"
						:placeholder="'School'"
						:options="schools"
						:labels="schools.map(school => school.name)"
						v-model="filters.School">
					</Dropdown>
					<Dropdown
						v-if="filters.School"
						:brick="true"
						:placeholder="'Program'"
						:options="programs"
						:labels="programs.map(program => program.title)"
						v-model="filters.Program">
					</Dropdown>
					<Dropdown
						v-if="filters.Program"
						:brick="true"
						:placeholder="'Year'"
						:options="years"
						:labels="yearLabels"
						v-model="filters.year">
					</Dropdown>
					<Dropdown
						v-if="filters.year"
						:brick="true"
						:placeholder="'Course'"
						:options="yearCourses"
						:labels="yearCourses.map(course => course.title)"
						v-model="filters.Course">
					</Dropdown>
				</div>
			</div>
			<div v-if="filters.Course" class="explore__results">
				<PlanningGrid :plannings="plannings"></PlanningGrid>
			</div>
		</div>
	</div>
</template>

<script>
import Dropdown from '@/components/Dropdown'
import PlanningGrid from '@/components/PlanningGrid'
import PlanningService from '@/services/PlanningService'
import SchoolService from '@/services/SchoolService'
export default {
	data () {
		return {
			filters: {
				School: null,
				Program: null,
				year: null,
				Course: null
			},
			plannings: null,
			schools: [],
			programs: [],
			years: [],
			yearLabels: [],
			courses: []
		}
	},
	components: {
		Dropdown,
		PlanningGrid
	},
	methods: {
		async getPlannings () {
			this.plannings = await PlanningService.getAll({
				course: this.filters.Course.id
			})
		},
		async getSchools () {
			this.schools = await SchoolService.getSchools()
		},
		async getPrograms () {
			this.programs = await SchoolService.getPrograms(this.filters.School.id)
		},
		async getCourses () {
			if (!this.filters.Program) this.courses = []
			else {
				this.courses = await SchoolService.getCourses(this.filters.Program.id)
				this.years = SchoolService.getCourseYears(this.courses)
				var yearLabels = []
				this.years.forEach(year => yearLabels.push('Year ' + year))
				this.yearLabels = yearLabels
			}
		},
		async setDefaults () {
			if (this.$store.state.authentication.user.School) {
				// Set school
				const schoolId = this.$store.state.authentication.user.School.id
				this.filters.School = this.schools.find(school => school.id === schoolId)
				await this.getPrograms()
				if (this.$store.state.authentication.user.Program) {
					// Set program
					const programId = this.$store.state.authentication.user.Program.id
					this.filters.Program = this.programs.find(program => program.id === programId)
				}
			}
		}
	},
	computed: {
		yearCourses () {
			return this.courses.filter(course => course.year === this.filters.year)
		}
	},
	watch: {
		'filters.School' () {
			if (this.setup) {
				this.filters.Program = null
				this.getPrograms()
			}
		},
		'filters.Program' () {
			this.filters.year = null
			this.getCourses()
		},
		'filters.year' () {
			this.filters.Course = null
		},
		'filters.Course' () {
			if (this.filters.Course) this.getPlannings()
		}
	},
	async created () {
		await this.getSchools()
		await this.setDefaults()
		this.setup = true
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/views/_explore.scss";
</style>
